module.exports = __webpack_public_path__ + "fonts/Tracks-Italic.ttf";